import { combineReducers } from 'redux';

const initialState = {
    userList:undefined,
    userListCount:0,
    userCreated:false,

};


const userListData = (state = initialState, action) => {
    switch(action.type){
        case "USER_DATA_SUCCESS":
            return {
                ...state,
                userList  : (action.userData&& action.userData.data? (action.userData.data.response) : state.userList),
                userListCount : (action.userData&& action.userData.data&& action.userData.data.response) ? action.userData.data.response.length : state.userListCount
            }
        case "USER_DATA_SEARCH_SUCCESS":
            return {
                ...state,
                filteredData : action.filteredData ? action.filteredData:state.filteredData,
                userListCount :  action.filteredData ? action.filteredData.length :state.userListCount,
                searchText : action.searchText?action.searchText:'',
                userid : action.userid?'1':'',
                sort : action.sort?action.sort : 'new'

            }
        case "CREATE_USER":
            return {
                ...state,
                userCreated  : !state.userCreated
            }
        default:
            return state;
    }
}


const user = combineReducers({
    userListData
})

export default user;
export const getUserData = state => state.user.userListData;


// WEBPACK FOOTER //
// ./src/reducers/user.js